import { createSelector } from 'reselect';
import { data as dataSelector, data2 as data2Selector } from '../AdvWorkflow/AdvWorkflowSelector';
import { BACKEND_KEY } from './HealthcareWorkflowConstants';

export const healthcareGoalSelector = createSelector(
  dataSelector,
  data2Selector,
  (data, data2) => ({ ...data(BACKEND_KEY), ...data2(BACKEND_KEY) }),
);

export const yearsOptionsSelector = createSelector(
  dataSelector,
  data => data('YearOptions') || [],
);
